// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/InterVariable.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/InterVariable-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Urbanist-VariableFont_wght.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Urbanist-Italic-VariableFont_wght.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Inter';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
    format('woff2-variations');
    font-weight: 100 900;
    font-style: normal;
    font-display: block;
}

@font-face {
    font-family: 'Inter';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}),
    format('woff2-variations');
    font-weight: 100 900;
    font-style: italic;
    font-display: block;
}

@font-face {
    font-family: 'Urbanist';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}),
    format('woff2-variations');
    font-weight: 100 900;
    font-style: normal;
    font-display: block;
}

@font-face {
    font-family: 'Urbanist';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}),
    format('woff2-variations');
    font-weight: 100 900;
    font-style: italic;
    font-display: block;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Urbanist', serif;
    font-weight: 550;
}

input, button {
    appearance: none;
    border: none;
    outline: none;
}

h1, h2, h3, h4, h5, h6 {
    font-family: 'Inter', sans-serif;
    font-weight: 200;
}

body {
    background-color: rgb(210, 210, 210);
    margin: 1rem 2rem;
}

header {
    padding: 1rem 2rem;
    background-color: white;
    border-radius: 48px;
    box-shadow: 0 0.5rem 1rem;
    position: sticky;
    top: 1rem;
    margin: 0 -1rem 2rem -1rem;
}

nav {
    display: flex;
    justify-content: center;
    gap: 2.5rem;
    flex-wrap: wrap;
}

nav > button {
    font-family: 'Inter', sans-serif;
    font-weight: 200;
    font-size: 2.5rem;
    background-color: rgb(139, 189, 254);
    padding: 1rem 2rem;
    border-radius: 2rem;
}

nav > button:hover {
    background-color: rgb(202, 225, 255);
    box-shadow: 0 0.25rem 0.5rem;
    font-weight: 600;
}

.content-card {
    background-color: white;
    padding: 1rem;
    margin: 1rem auto;
    border-radius: 48px;
}

.hero-card {
    padding: 1rem 2rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 2rem;
}

.hero-card-text {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-basis: 35%;
}

.restaurant-name {
    font-size: 5rem;
    margin-bottom: -0.5rem;
}

.location {
    font-size: 2rem;
}

.tagline {
    margin-top: 5rem;
    font-size: 2rem;
}

.hero-photo {
    flex-basis: 60%;
    height: auto;
    flex-grow: 1;
    min-width: 0;
    display: block;
    border-radius: 2rem;
}

.card {
    background-color: rgb(210, 210, 210);
    border-radius: 32px;
    padding: 1rem 2rem;
}

.detail.card {
    display: flex;
    flex-wrap: wrap;
    background-color: transparent;
    white-space: pre-line;
    justify-content: space-evenly;
    gap: 1rem;
    padding: 1rem;
}

.hour-title, .location-title {
    font-size: 2.5rem;
}

.hour-text, .location-text {
    font-size: 1.5rem;
}

.title-card {
    background-color: rgb(210, 210, 210);
    padding: 1rem 2rem;
    border-radius: 32px;
    margin-bottom: 1rem;
}

.title {
    text-align: center;
    font-size: 5rem;
    margin-bottom: 1rem;
}

.title-card-text {
    font-size: 2rem;
    text-align: center;
}

.menu.small-title {
    font-size: 3rem;
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-align: center;
    margin-top: 2rem;
}

.menu.text {
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 2rem;
}

.food.card {
    display: grid;
    grid-template-columns: 4fr 1fr;
    grid-template-rows: repeat(3, max-content);
    column-gap: 1rem;
    margin-bottom: 1rem;
}

.food.name {
    font-size: 3.5rem;
    grid-column: 1;
    grid-row: 1;
}

.food.text {
    font-size: 1.5rem;
    grid-column: 1;
    grid-row: 2;
    margin-bottom: 1rem;
}

.food.price {
    font-size: 3rem;
    grid-column: 2;
    grid-row: 1 / 3;
    place-self: center;
}

.food.note {
    font-size: 1rem;
    grid-column: 1 / 3;
    grid-row: 3;
}

.drinks-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    justify-content: center;
    gap: 1rem;
}

.drink.card {
    display: grid;
    grid-template-columns: 1fr 4fr;
    grid-template-rows: repeat(4, max-content);
    column-gap: 1rem;
}

.drink.name {
    font-size: 3.5rem;
    grid-column: 1 / 3;
    grid-row: 1;
}

.hot.text {
    font-size: 2rem;
    grid-column: 1;
    grid-row: 2;
}

.hot.price {
    font-size: 2rem;
    grid-column: 2;
    grid-row: 2;
}

.cold.text {
    font-size: 2rem;
    grid-column: 1;
    grid-row: 3;
}

.cold.price {
    font-size: 2rem;
    grid-column: 2;
    grid-row: 3;
}

.drink.note {
    font-size: 1rem;
    grid-column: 1 / 3;
    grid-row: 4;
}

.section-title {
    font-size: 4rem;
    text-align: center;
}

.section-container {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    margin-top: 5rem;
}

.text-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-basis: 35%;
    gap: 1rem;
}

.section-date {
    font-size: 3rem;
}

.section-text {
    font-size: 1.5rem;
    line-height: 1.5;
}

.section-photo {
    flex-basis: 60%;
    height: auto;
    width: 100%;
    flex-grow: 1;
    min-width: 0;
    display: block;
    border-radius: 2rem;
}

.about.card {
    margin-top: 2rem;
}

.improvement-text {
    font-size: 1.5rem;
    line-height: 1.5;
    text-align: center;
    margin-bottom: 2rem;
}

.improvement-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    justify-content: center;
    gap: 5rem;    
}

.improvement.item {
    background-color: white;
    display: grid; 
    grid-template-columns: max-content, max-content;
    border-radius: 32px;
    width: minmax(400px, 1fr);
}

.improvement-photo {
    height: auto;
    width: 100%;
    min-width: 0;
    display: block;
    border-radius: 32px;
}

.improvement-text.item {
    font-size: 2rem;
    padding: 1rem 2rem;
    place-self: center;
}

.improvement.section-title {
    margin-bottom: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB;8BAC0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB;8BAC0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB;8BAC0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB;8BAC0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,qBAAqB;IACrB,6BAA6B;IAC7B,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,0CAA0C;IAC1C,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,+CAA+C;IAC/C,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["@font-face {\n    font-family: 'Inter';\n    src: url(./fonts/InterVariable.woff2),\n    format('woff2-variations');\n    font-weight: 100 900;\n    font-style: normal;\n    font-display: block;\n}\n\n@font-face {\n    font-family: 'Inter';\n    src: url(./fonts/InterVariable-Italic.woff2),\n    format('woff2-variations');\n    font-weight: 100 900;\n    font-style: italic;\n    font-display: block;\n}\n\n@font-face {\n    font-family: 'Urbanist';\n    src: url(./fonts/Urbanist-VariableFont_wght.woff2),\n    format('woff2-variations');\n    font-weight: 100 900;\n    font-style: normal;\n    font-display: block;\n}\n\n@font-face {\n    font-family: 'Urbanist';\n    src: url(./fonts/Urbanist-Italic-VariableFont_wght.woff2),\n    format('woff2-variations');\n    font-weight: 100 900;\n    font-style: italic;\n    font-display: block;\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: 'Urbanist', serif;\n    font-weight: 550;\n}\n\ninput, button {\n    appearance: none;\n    border: none;\n    outline: none;\n}\n\nh1, h2, h3, h4, h5, h6 {\n    font-family: 'Inter', sans-serif;\n    font-weight: 200;\n}\n\nbody {\n    background-color: rgb(210, 210, 210);\n    margin: 1rem 2rem;\n}\n\nheader {\n    padding: 1rem 2rem;\n    background-color: white;\n    border-radius: 48px;\n    box-shadow: 0 0.5rem 1rem;\n    position: sticky;\n    top: 1rem;\n    margin: 0 -1rem 2rem -1rem;\n}\n\nnav {\n    display: flex;\n    justify-content: center;\n    gap: 2.5rem;\n    flex-wrap: wrap;\n}\n\nnav > button {\n    font-family: 'Inter', sans-serif;\n    font-weight: 200;\n    font-size: 2.5rem;\n    background-color: rgb(139, 189, 254);\n    padding: 1rem 2rem;\n    border-radius: 2rem;\n}\n\nnav > button:hover {\n    background-color: rgb(202, 225, 255);\n    box-shadow: 0 0.25rem 0.5rem;\n    font-weight: 600;\n}\n\n.content-card {\n    background-color: white;\n    padding: 1rem;\n    margin: 1rem auto;\n    border-radius: 48px;\n}\n\n.hero-card {\n    padding: 1rem 2rem;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 2rem;\n}\n\n.hero-card-text {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    flex-basis: 35%;\n}\n\n.restaurant-name {\n    font-size: 5rem;\n    margin-bottom: -0.5rem;\n}\n\n.location {\n    font-size: 2rem;\n}\n\n.tagline {\n    margin-top: 5rem;\n    font-size: 2rem;\n}\n\n.hero-photo {\n    flex-basis: 60%;\n    height: auto;\n    flex-grow: 1;\n    min-width: 0;\n    display: block;\n    border-radius: 2rem;\n}\n\n.card {\n    background-color: rgb(210, 210, 210);\n    border-radius: 32px;\n    padding: 1rem 2rem;\n}\n\n.detail.card {\n    display: flex;\n    flex-wrap: wrap;\n    background-color: transparent;\n    white-space: pre-line;\n    justify-content: space-evenly;\n    gap: 1rem;\n    padding: 1rem;\n}\n\n.hour-title, .location-title {\n    font-size: 2.5rem;\n}\n\n.hour-text, .location-text {\n    font-size: 1.5rem;\n}\n\n.title-card {\n    background-color: rgb(210, 210, 210);\n    padding: 1rem 2rem;\n    border-radius: 32px;\n    margin-bottom: 1rem;\n}\n\n.title {\n    text-align: center;\n    font-size: 5rem;\n    margin-bottom: 1rem;\n}\n\n.title-card-text {\n    font-size: 2rem;\n    text-align: center;\n}\n\n.menu.small-title {\n    font-size: 3rem;\n    text-decoration: underline;\n    text-decoration-thickness: 2px;\n    text-align: center;\n    margin-top: 2rem;\n}\n\n.menu.text {\n    font-size: 1.5rem;\n    text-align: center;\n    margin-bottom: 2rem;\n}\n\n.food.card {\n    display: grid;\n    grid-template-columns: 4fr 1fr;\n    grid-template-rows: repeat(3, max-content);\n    column-gap: 1rem;\n    margin-bottom: 1rem;\n}\n\n.food.name {\n    font-size: 3.5rem;\n    grid-column: 1;\n    grid-row: 1;\n}\n\n.food.text {\n    font-size: 1.5rem;\n    grid-column: 1;\n    grid-row: 2;\n    margin-bottom: 1rem;\n}\n\n.food.price {\n    font-size: 3rem;\n    grid-column: 2;\n    grid-row: 1 / 3;\n    place-self: center;\n}\n\n.food.note {\n    font-size: 1rem;\n    grid-column: 1 / 3;\n    grid-row: 3;\n}\n\n.drinks-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    justify-content: center;\n    gap: 1rem;\n}\n\n.drink.card {\n    display: grid;\n    grid-template-columns: 1fr 4fr;\n    grid-template-rows: repeat(4, max-content);\n    column-gap: 1rem;\n}\n\n.drink.name {\n    font-size: 3.5rem;\n    grid-column: 1 / 3;\n    grid-row: 1;\n}\n\n.hot.text {\n    font-size: 2rem;\n    grid-column: 1;\n    grid-row: 2;\n}\n\n.hot.price {\n    font-size: 2rem;\n    grid-column: 2;\n    grid-row: 2;\n}\n\n.cold.text {\n    font-size: 2rem;\n    grid-column: 1;\n    grid-row: 3;\n}\n\n.cold.price {\n    font-size: 2rem;\n    grid-column: 2;\n    grid-row: 3;\n}\n\n.drink.note {\n    font-size: 1rem;\n    grid-column: 1 / 3;\n    grid-row: 4;\n}\n\n.section-title {\n    font-size: 4rem;\n    text-align: center;\n}\n\n.section-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2rem;\n    margin-top: 5rem;\n}\n\n.text-container {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    flex-basis: 35%;\n    gap: 1rem;\n}\n\n.section-date {\n    font-size: 3rem;\n}\n\n.section-text {\n    font-size: 1.5rem;\n    line-height: 1.5;\n}\n\n.section-photo {\n    flex-basis: 60%;\n    height: auto;\n    width: 100%;\n    flex-grow: 1;\n    min-width: 0;\n    display: block;\n    border-radius: 2rem;\n}\n\n.about.card {\n    margin-top: 2rem;\n}\n\n.improvement-text {\n    font-size: 1.5rem;\n    line-height: 1.5;\n    text-align: center;\n    margin-bottom: 2rem;\n}\n\n.improvement-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n    justify-content: center;\n    gap: 5rem;    \n}\n\n.improvement.item {\n    background-color: white;\n    display: grid; \n    grid-template-columns: max-content, max-content;\n    border-radius: 32px;\n    width: minmax(400px, 1fr);\n}\n\n.improvement-photo {\n    height: auto;\n    width: 100%;\n    min-width: 0;\n    display: block;\n    border-radius: 32px;\n}\n\n.improvement-text.item {\n    font-size: 2rem;\n    padding: 1rem 2rem;\n    place-self: center;\n}\n\n.improvement.section-title {\n    margin-bottom: 2rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
